import * as React from "react";
import {
  FormControl,
  FormHelperText,
  MenuItem,
  InputLabel,
  Select,
} from "@mui/material";
import { Enum } from "src/common/enum";

interface SelectFieldProps {
    error?: boolean;
    onChange?: any;
    choices?: Enum[];
    children?: any;
    required?: boolean;
    multiple?: boolean
    helperText?: string;
    size?: "small" | "medium";
    label?: string;
    sx?: any;
    value?: any;
    defaultValue?: any;
  }

export const SelectField = React.forwardRef((props: SelectFieldProps, ref) => {
    const { label, error = false, onChange, choices = [], required = false, helperText, size = "medium", sx, children, ...rest } = props;
    
    return (
        <FormControl
            fullWidth
            sx={{...sx, backgroundColor: "#fff"}}
            required={required}
        >
            { label && <InputLabel error={error}>{label}</InputLabel> }
            <Select
                size={size}
                onChange={onChange}
                variant="outlined"
                error={error}
                {...rest}
            >
                {children ?? choices.map((item) => (
                    <MenuItem
                        key={item.id}
                        value={item.id}
                        disabled={item.disabled || false}
                    >
                        {item.name}
                    </MenuItem>
                ))}
            </Select>
            { helperText && <FormHelperText error={error}>{helperText}</FormHelperText> }
        </FormControl>
    );
});
